import React, {useState, useEffect} from "react"
import { Link } from "react-router-dom"
import { Row, Col, Card } from "reactstrap"

//Import Images
import profileImg from "../../assets/images/profile-img.png"
import TopCategories from "./TopCategories"
import TopComplaintStatus from "./TopComplaintStatus"

function CardWelcome(props) {
  const [username, setUsername] = useState("")
  const [role, setrole] = useState("")
  const [employeeNo, setEmployeeNo] = useState("")

  useEffect(() => {
    if (localStorage.getItem("authWTUser")) {
        const obj = JSON.parse(localStorage.getItem("authWTUser"))
        setUsername(obj.username)
        setEmployeeNo(obj.uid)
        setrole(obj.role)
    }
  }, [])
  return (
    <React.Fragment>
    <TopComplaintStatus/>
    
    <TopCategories/>
   
  </React.Fragment>
  );
}

export default CardWelcome;